var _defs, _rect, _rect2, _rect3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDozyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Dozy",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dozyBrand",
    x1: 12,
    y1: 10,
    x2: 84,
    y2: 86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7C5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4AA8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22D3EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dozyGlass",
    x1: 20,
    y1: 14,
    x2: 60,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ffffff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "dozyGlow",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "b"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 84,
    height: 84,
    rx: 24,
    fill: "url(#dozyBrand)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 84,
    height: 84,
    rx: 24,
    fill: "url(#dozyGlass)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.75,
    y: 6.75,
    width: 82.5,
    height: 82.5,
    rx: 23.25,
    fill: "none",
    stroke: "#ffffff",
    strokeOpacity: 0.25,
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#dozyGlow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 26 A22 22 0 1 1 40 70",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 9,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.5,
    y: 24,
    width: 9,
    height: 48,
    rx: 4.5,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 41 L51 50 L57 50 L53 60 L64 48 L58 48 Z",
    fill: "#06070F",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDozyLogo);
export default __webpack_public_path__ + "static/media/dozy-logo.4bb2ccda8f883454895ac5222b8adc2b.svg";
export { ForwardRef as ReactComponent };